/**
 * @module services/Search.js
 */
import { AnnotationRecipeTypes } from './constants';
import * as D from './deps';
import { parseSearchResultItems } from './utils';

export function search({
  query = '',
  searchTypes = [],
  start = 0,
  count = 50,
  searchTime = null,
  cancelToken,
  searchFilter,
  searchType,
}: $TSFixMe) {
  D.Utils.Time.markTimeAtMomentForQuery(
    D.Constants.App.SearchCheckpointMarks.SEARCH_STATS_SOD_REQUEST,
    query,
  );
  return D.Api.apiRequest({
    endpoint: D.ApiEndpoints.SOD_SEARCH,
    content: {
      query,
      types: searchTypes,
      listener: null,
      start,
      count,
      annotate: true,
      searchTime,
      annotationRecipe: AnnotationRecipeTypes.CLASS_OF_2019,
    },
    searchFilter,
    searchType,
    cancelToken,
    parser: parseSearchResultItems,
  });
}
